import { Component, OnInit } from "@angular/core";
import { Select } from "@ngxs/store";
import { Observable } from "rxjs";
import { GlobalStateModel } from "../../shared/model/global.model";
import { ConfigurationSandbox } from "../../shared/sandbox/providers/configuration.sandbox";
import { GlobalSandbox } from "../../shared/sandbox/providers/global.sandbox";
import { GlobalState } from "../../shared/store/state/global.state";

@Component({
  selector: "id3-barcode-type-selection",
  templateUrl: "./barcode-type-selection.component.html",
  styleUrls: ["./barcode-type-selection.component.css"],
  providers: [ConfigurationSandbox],
})
export class BarcodeTypeSelectionComponent implements OnInit {
  constructor(
    public globalSandbox: GlobalSandbox,
    public configurationSandbox: ConfigurationSandbox
  ) {}

  ngOnInit(): void {
    this.configurationSandbox.startState();
  }
}
